import promoReducer from './PromoAdd/reducer';
import promoRootReducer from './reducer/index';
import { combineReducers } from 'redux';

export default combineReducers({ promoRootReducer, promoReducer });
